module.exports = __webpack_public_path__ + "img/background-voucher-landing-desktop.77e1723.png";